import { IUser } from "../../api/services/auth/models";
import { IMyInfoData } from "../../api/services/profile/models";
import { parseJSONFunc } from "../../util/helpers";

export class AuthConfig {
  private static readonly tokenKey = "userToken";
  static readonly setToken = (token: string | null) => {
    try {
      if (token === null) {
        window.localStorage.removeItem(AuthConfig.tokenKey);
      } else {
        window.localStorage.setItem(AuthConfig.tokenKey, token);
      }
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
    }
  };
  static readonly getToken: () => string | null = () => {
    try {
      const userToken = window.localStorage.getItem(AuthConfig.tokenKey);
      return userToken;
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
      return null;
    }
  };

  private static readonly refreshTokenKey = "userRefreshToken";
  static readonly setRefreshToken = (token: string | null) => {
    try {
      if (token === null) {
        window.localStorage.removeItem(AuthConfig.refreshTokenKey);
      } else {
        window.localStorage.setItem(AuthConfig.refreshTokenKey, token);
      }
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
    }
  };
  static readonly getRefreshToken: () => string | null = () => {
    try {
      return window.localStorage.getItem(AuthConfig.refreshTokenKey);
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
      return null;
    }
  };

  private static readonly expiresAt = "expiresAt";
  static readonly setExpiresAt = (time: string | null) => {
    try {
      if (time === null) {
        window.localStorage.removeItem(AuthConfig.expiresAt);
      } else {
        window.localStorage.setItem(AuthConfig.expiresAt, time);
      }
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
    }
  };
  static readonly getExpiresAt: () => string | null = () => {
    try {
      return window.localStorage.getItem(AuthConfig.expiresAt);
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
      return null;
    }
  };

  private static readonly userInfoKey = "userInfo";
  static readonly setUserInfo = (info?: IUser | null) => {
    try {
      if (info) {
        const userInfoString = JSON.stringify(info);
        window.localStorage.setItem(AuthConfig.userInfoKey, userInfoString);
      } else {
        window.localStorage.removeItem(AuthConfig.userInfoKey);
      }
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
    }
  };
  static readonly getUserInfo: () => IUser = () => {
    try {
      const userInfo = window?.localStorage?.getItem(AuthConfig.userInfoKey);
      if (userInfo) {
        return parseJSONFunc(userInfo);
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  private static readonly myInfoKey = "myInfo";
  static readonly setMyInfo = (info?: IMyInfoData | null) => {
    try {
      if (info) {
        const myInfoString = JSON.stringify(info);
        window.localStorage.setItem(AuthConfig.myInfoKey, myInfoString);
      } else {
        window.localStorage.removeItem(AuthConfig.myInfoKey);
      }
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
    }
  };
  static readonly getMyInfo: () => IMyInfoData = () => {
    try {
      const myInfoString = window.localStorage.getItem(AuthConfig.myInfoKey);
      if (myInfoString) {
        return parseJSONFunc(myInfoString);
      }
      return null;
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
      return null;
    }
  };

  private static readonly appTokenKey = "appTokenKey";
  private static readonly appTokenExpiryDateKey = "appTokenExpiryDateKey";
  static readonly setAppToken = (token: string | null, expires_in?: string) => {
    try {
      if (token === null) {
        window.localStorage.removeItem(AuthConfig.appTokenKey);
        window.localStorage.removeItem(AuthConfig.appTokenExpiryDateKey);
      } else {
        window.localStorage.setItem(AuthConfig.appTokenKey, token);
        expires_in &&
          window.localStorage.setItem(
            AuthConfig.appTokenExpiryDateKey,
            expires_in
          );
      }
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
    }
  };
  static readonly getAppToken: () => string | null = () => {
    try {
      const expiryDate = window.localStorage.getItem(
        AuthConfig.appTokenExpiryDateKey
      );
      const isExpired = () => {
        const now = new Date();
        const expiresAt = new Date(expiryDate || "");
        return expiresAt.getTime() - now.getTime() < 0;
      };
      if (isExpired() || !expiryDate) return null;
      return window.localStorage.getItem(AuthConfig.appTokenKey);
    } catch (error) {
      console.error(`Error managing data from localStorage: ${error}`);
      return null;
    }
  };
}
